import {
    PRODUCT_MOTUL_ALLOWED_IMAGE_EXTENSIONS,
    PRODUCT_MOTUL_ALLOWED_IMAGE_MIME_TYPES,
    PRODUCT_MOTUL_IMAGE_LIMIT,
    PRODUCT_MOTUL_MAX_FILE_SIZE
} from "./productMotulImageConfig";

export const buildProductMotulImageSrc = (image) => {
    if (!image?.base64Image) {
        return "";
    }

    const contentType = image.contentType || "image/png";
    return `data:${contentType};base64,${image.base64Image}`;
};

export const validateProductMotulImageSelection = ({ files, persistedCount, pendingCount, t }) => {
    const selectedFiles = Array.from(files || []);
    if (selectedFiles.length === 0) {
        return "";
    }

    if (persistedCount + pendingCount + selectedFiles.length > PRODUCT_MOTUL_IMAGE_LIMIT) {
        return t("productMotulImagesLimit");
    }

    const invalidExtension = selectedFiles.find((file) => {
        const lowerName = String(file?.name || "").toLowerCase();
        return !PRODUCT_MOTUL_ALLOWED_IMAGE_EXTENSIONS.some((extension) => lowerName.endsWith(extension));
    });

    if (invalidExtension) {
        return t("productMotulImagesInvalidFormat");
    }

    const invalidMime = selectedFiles.find((file) => !PRODUCT_MOTUL_ALLOWED_IMAGE_MIME_TYPES.includes(file?.type));
    if (invalidMime) {
        return t("productMotulImagesInvalidMimeType");
    }

    const invalidSize = selectedFiles.find((file) => Number(file?.size || 0) > PRODUCT_MOTUL_MAX_FILE_SIZE);
    if (invalidSize) {
        return t("productMotulImagesFileTooLarge");
    }

    return "";
};
